<template>
  <div class="economic-volume">
    <div class="title">
      <span>广东省经济进出口额</span>
    </div>
    <div class="chart-con">
      <TabList
        :list="tabList"
        :act="tabIndex"
        class="po"
        @clickItem="
          (item, i) => {
            tabIndex = i;
          }
        "
      />
      <v-chart ref="bar-chart" id="bar-chart" class="bar-chart" :options="chartOption" />
    </div>
  </div>
</template>

<script>
// import drawBar from '../chartJs/chartEconomicVolume';
import drawBar from '../chartJs/chartFixedAssetInvestment';
import { getEconomicVolumeData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
export default {
  name: 'EconomicVolume',
  components: { TabList },
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      tabList: [
        {
          label: '进口',
        },
        {
          label: '出口',
        },
      ],
      tabIndex: 1,
      chartOption: null,
      chartData: null,
    };
  },
  watch: {
    tabIndex(n) {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.$refs['bar-chart'].clear();
      this.$api.screen
        .getInoutVolume({
          caliber: this.tabList[this.tabIndex].label,
          endYear: this.yearP,
        })
        .then((res) => {
          let { data } = res.data;
          let names = [],
            listData = {};
          if (data && data.yData?.length) {
            let fI = 0,
              lI = data.yData[0].data.length;
            names = data.yData
              .map((item) => {
                if (item.name.includes('金额')) {
                  item.name = item.name.slice(0, 2);
                }
                listData[item.name] = item.data;
                const firstIndex = item.data.findIndex((x) => x !== null && x !== '');
                const lastIndex = item.data.findLastIndex((x) => x !== null && x !== '') + 1;
                if (firstIndex !== -1 && firstIndex > fI) fI = firstIndex;
                if (lastIndex !== -1 && (lI === item.data.length || lastIndex > lI)) lI = lastIndex;
                return item.name;
              })
              .filter((item) => item.length < 4);
            names.push('民营占比');
            listData['年份'] = data.xData;
            for (const key in listData) {
              if (Object.hasOwnProperty.call(listData, key)) {
                const element = listData[key];
                listData[key] = element.slice(fI, lI);
              }
            }
          }
          let list = {
            yAxis: {
              names: ['单位：亿元', '单位：%'],
            },
            names,
            legend: {
              top: '6%',
              left: '6%',
            },
            grid: {
              top: '35%',
            },
            // colorOpacity: true,
            data: [],
          };
          for (let i = 0; i < listData['年份'].length; i++) {
            let obj = {
              年份: listData['年份'][i],
              全量: '',
              民营: '',
              民营占比: '',
            };
            for (let key in listData) {
              obj[key] = listData[key][i];
            }
            obj['民营占比'] = Math.round(obj['民营占比'] * 100 * 100) / 100;
            list.data.push(obj);
          }
          this.chartData = list;
          this.chartOption = drawBar(list);
        });

      // getEconomicVolumeData().then(res => {
      //   let type = this.tabList[this.tabIndex].label;
      //   let reaData = res.RECORDS.filter(item => item['类型'] === type);
      //   let year = new Set();
      //   let names = new Set();
      //   reaData.map((item) => {
      //     year.add(item['年份']);
      //     names.add(item['指标']);
      //     // data.push(item['总数'])
      //   });
      //
      //   this.$nextTick(() => {
      //     let list = {
      //       yAxis: {
      //         names: ['单位：亿元', '单位：%']
      //       },
      //       names: Array.from(names),
      //       legend: {
      //         top: '6%',
      //         left: '6%'
      //       },
      //       grid: {
      //         top: '35%'
      //       },
      //       // colorOpacity: true,
      //       data: []
      //     };
      //     let data = {};
      //     data.year = Array.from(year);
      //     data.full = this.filterData(reaData, '全量', '总数', '指标');
      //     data.private = this.filterData(reaData, '民营', '总数', '指标');
      //     data.proportion = this.filterData(reaData, '民营占比', '总数', '指标');
      //     for (let i = 0; i < data.year.length; i++) {
      //       data.proportion[i] = Math.round(data.proportion[i] * 100 * 100) / 100;
      //       // data.proportion[i] = (Math.round(data.proportion[i] * 100 * 100 * 100) / 100 / 100).toFixed(2);
      //       list.data.push({
      //         年份: data.year[i],
      //         全量: data.full[i],
      //         民营: data.private[i],
      //         民营占比: data.proportion[i]
      //       });
      //     }
      //     this.chartData = list;
      //     this.chartOption = drawBar(list)
      //   })
      // })
    },
    filterData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          arr.push(Number(data[key][keyName]));
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.economic-volume {
  .chart-box();

  /deep/.tab-list {
    .tab-item {
      min-width: 60px;
    }
  }
}
</style>
